
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                <i className="ri-store-2-line text-white text-lg"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                ListIt
              </span>
            </div>
            <p className="text-gray-400 mb-4">
              Nigeria's modern marketplace for buying and selling locally. Connect with verified sellers and buyers across the country.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Categories</h3>
            <ul className="space-y-2">
              <li><a href="/category/real-estate" className="text-gray-400 hover:text-white">Real Estate</a></li>
              <li><a href="/category/vehicles" className="text-gray-400 hover:text-white">Vehicles</a></li>
              <li><a href="/category/electronics" className="text-gray-400 hover:text-white">Electronics</a></li>
              <li><a href="/category/services" className="text-gray-400 hover:text-white">Services</a></li>
              <li><a href="/category/jobs" className="text-gray-400 hover:text-white">Jobs</a></li>
              <li><a href="/category/fashion" className="text-gray-400 hover:text-white">Fashion</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="/help" className="text-gray-400 hover:text-white">Help Center</a></li>
              <li><a href="/safety" className="text-gray-400 hover:text-white">Safety Tips</a></li>
              <li><a href="/contact" className="text-gray-400 hover:text-white">Contact Us</a></li>
              <li><a href="/report" className="text-gray-400 hover:text-white">Report Listing</a></li>
              <li><a href="/feedback" className="text-gray-400 hover:text-white">Feedback</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-400 hover:text-white">About Us</a></li>
              <li><a href="/careers" className="text-gray-400 hover:text-white">Careers</a></li>
              <li><a href="/press" className="text-gray-400 hover:text-white">Press</a></li>
              <li><a href="/terms" className="text-gray-400 hover:text-white">Terms of Service</a></li>
              <li><a href="/privacy" className="text-gray-400 hover:text-white">Privacy Policy</a></li>
              <li><a href="/admin/login" className="text-gray-400 hover:text-emerald-400 transition-colors">
                <i className="ri-shield-user-line mr-1"></i>Admin Login
              </a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 ListIt Nigeria. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
